// extracted by mini-css-extract-plugin
module.exports = {"green700":"#abe7e1","green500":"#2ec2b3","green300":"#179e8f"};